"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[952],{

/***/ 89497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 0 ",
        "px;\n  border-radius: 999px;\n  background: ",
        ";\n  color: ",
        ";\n  ",
        ";\n  font-weight: 600;\n\n  &:active {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var tagListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xsmall */ .Ki.xsmall);
var tagChipCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, theme.colors.main50, theme.colors.main500, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Typography.body12 */ .ZT.body12);
};
var CommunityTagList = function(param) {
    var tags = param.tags, onTagClick = param.onTagClick;
    if (!(tags === null || tags === void 0 ? void 0 : tags.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: tagListCSS,
        children: tags.map(function(tag) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                css: tagChipCSS,
                onClick: function(e) {
                    if (!onTagClick) {
                        return;
                    }
                    e.stopPropagation();
                    onTagClick(tag);
                },
                children: [
                    "#",
                    tag
                ]
            }, "community-tag-".concat(tag));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityTagList);


/***/ }),

/***/ 23468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71618);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83898);
/* harmony import */ var _components_common_ImageCarousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16482);
/* harmony import */ var _components_modal_ImageModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11502);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96964);
/* harmony import */ var _utils_community__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85791);
/* harmony import */ var _utils_communityTags__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6891);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9987);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45874);
/* harmony import */ var _common_Avatar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81649);
/* harmony import */ var _user_Nickname__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87682);
/* harmony import */ var _CommunityTagList__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89497);
/* harmony import */ var _MentionCards__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66889);
/* harmony import */ var _MentionText__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26581);
/* harmony import */ var _PollDisplay__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89831);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: ",
        "px;\n\n    .profile {\n      display: flex;\n      align-items: center;\n    }\n\n    .nickname {\n      margin-left: ",
        "px;\n\n      .fixedContainer {\n        display: flex;\n        align-items: center;\n        gap: ",
        "px;\n      }\n\n      small {\n        display: block;\n        margin-top: ",
        "px;\n        color: ",
        ";\n        ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\00a0';\n  }\n"
    ], [
        "\n  color: ",
        ";\n\n  &:before {\n    content: '\\\\00a0';\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  ",
        " {\n    max-width: 400px;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 12px;\n    overflow: hidden;\n  }\n  ",
        " {\n    max-width: 480px;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n  color: ",
        ";\n\n  button {\n    ",
        ";\n  }\n\n  button + button {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




















var postCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject());
var postFixedCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, theme.var.gray600);
};
var postUserCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12);
};
var postContentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body14 */ .ZT.body14);
var postTagListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject4(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall);
var postContentMoreBtnCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject5(), theme.var.gray500);
};
var postPictureCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.small */ .Ki.small, _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.tablet */ .BC.tablet, _styles_css__WEBPACK_IMPORTED_MODULE_7__/* .media.desktop */ .BC.desktop);
var postButtonCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall);
};
var Post = function(_param) {
    var tmp = _param.clip, isClip = tmp === void 0 ? false : tmp, onLike = _param.onLike, isMyPage = _param.isMyPage, handleActionSheet = _param.handleActionSheet, onPollVote = _param.onPollVote, onTagClick = _param.onTagClick, _post = _objectWithoutProperties(_param, [
        "clip",
        "onLike",
        "isMyPage",
        "handleActionSheet",
        "onPollVote",
        "onTagClick"
    ]);
    var post = _post;
    var id = post.id, user = post.user, content = post.content, likeCount = post.likeCount, commentCount = post.commentCount, isFixed = post.isFixed, isLiked = post.isLiked, created = post.created;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__.u)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isContentOpen = ref[0], setContentOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isImageModalOpen = ref1[0], setImageModalOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), imageModalIndex = ref2[0], setImageModalIndex = ref2[1];
    var postImages = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_community__WEBPACK_IMPORTED_MODULE_18__/* .getPostImages */ .I)(post);
    }, [
        post
    ]);
    var hasImages = postImages.length > 0;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_misc__WEBPACK_IMPORTED_MODULE_9__/* .trimStringByLine */ .z_)(content);
    }, [
        content
    ]), content1 = ref3[0], content2 = ref3[1];
    var displayTags = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_utils_communityTags__WEBPACK_IMPORTED_MODULE_19__/* .getCommunityTagNamesFromTags */ .LC)(post.tags);
    }, [
        post.tags
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isMyPage ? [
        {
            label: t("수정하기"),
            value: "modify"
        },
        {
            label: t("삭제하기"),
            value: "delete",
            isDanger: true
        }, 
    ] : [
        {
            label: t("신고하기"),
            value: "report"
        }
    ]), actions = ref4[0];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("article", {
        css: postCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                css: postUserCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        className: "profile",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_common_Avatar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, _objectSpread({
                                size: _common_Avatar__WEBPACK_IMPORTED_MODULE_10__/* .AvatarSize.medium */ .DZ.medium
                            }, user)),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                className: "nickname",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                        className: "fixedContainer",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_user_Nickname__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, _objectSpread({}, user))
                                            }),
                                            isFixed && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("p", {
                                                css: postFixedCSS,
                                                className: "icon-text",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .PinFill */ .Ft,
                                                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                                        color: theme.var.gray600
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                                        children: t("고정됨")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("small", {
                                        children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p6)(created)
                                    })
                                ]
                            })
                        ]
                    }),
                    handleActionSheet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_common_ActionSheet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        name: "post-card-action-".concat(post.id),
                        options: actions,
                        onSelect: function(value) {
                            return handleActionSheet(value, id);
                        },
                        children: function(open) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
                                className: "icon-btn",
                                onClick: open,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .VerticalEllipsis */ .oR,
                                    color: theme.var.gray400,
                                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small
                                })
                            });
                        }
                    })
                ]
            }),
            isClip ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("p", {
                css: postContentCSS,
                className: "multiline",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                        content: content1
                    }),
                    isContentOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                        content: content2
                    }),
                    !isContentOpen && content2 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                        css: postContentMoreBtnCSS,
                        className: "text-btn",
                        onClick: function(e) {
                            e.stopPropagation();
                            setContentOpen(true);
                        },
                        children: [
                            "...",
                            t("더보기")
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                css: postContentCSS,
                className: "multiline",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_MentionText__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    content: content
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_MentionCards__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                content: content
            }),
            !!displayTags.length && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                css: postTagListCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_CommunityTagList__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    tags: displayTags,
                    onTagClick: onTagClick
                })
            }),
            post.poll && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_PollDisplay__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                poll: post.poll,
                communityId: id,
                onVote: function(updatedPoll) {
                    onPollVote === null || onPollVote === void 0 ? void 0 : onPollVote(_objectSpreadProps(_objectSpread({}, post), {
                        poll: updatedPoll
                    }));
                }
            }),
            hasImages && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                css: postPictureCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_common_ImageCarousel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    images: postImages,
                    onClickImage: function(index) {
                        setImageModalIndex(index);
                        setImageModalOpen(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                css: postButtonCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                        className: "text-btn icon-text",
                        onClick: function(e) {
                            e.stopPropagation();
                            onLike === null || onLike === void 0 ? void 0 : onLike(post);
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                icon: isLiked ? chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .HeartFill */ .Ic : chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Heart */ .YK,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                color: isLiked ? theme.colors.red500 : theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                children: likeCount != null && likeCount > 0 ? likeCount : t("좋아요")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("button", {
                        className: "text-btn icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Comment */ .sv,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                                color: theme.var.gray500
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                children: commentCount != null && commentCount > 0 ? commentCount : t("댓글달기")
                            })
                        ]
                    })
                ]
            }),
            hasImages && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_components_modal_ImageModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                images: postImages,
                initialIndex: imageModalIndex,
                open: isImageModalOpen,
                onClose: function() {
                    return setImageModalOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Post);


/***/ }),

/***/ 80786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useScrollPosition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80875);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);



var ScrollPositionMemory = {};
var useScrollPosition = function(name) {
    var scrollPosition = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleScroll = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .raf */ .Wn)(function() {
            var scrollY = window.scrollY;
            scrollPosition.current = scrollY;
        }), 100);
        var _name;
        var _cachedScrollPosition = (_name = ScrollPositionMemory[name]) !== null && _name !== void 0 ? _name : 0;
        window.scrollTo(0, _cachedScrollPosition);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", handleScroll);
            if (scrollPosition.current !== null) {
                ScrollPositionMemory[name] = scrollPosition.current;
            }
        };
    }, [
        name
    ]);
    return;
};


/***/ }),

/***/ 6891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AY": function() { return /* binding */ getCommunityTagNamesWithRecommendations; },
/* harmony export */   "EH": function() { return /* binding */ getCommunityTagNamesWithInput; },
/* harmony export */   "LC": function() { return /* binding */ getCommunityTagNamesFromTags; },
/* harmony export */   "e1": function() { return /* binding */ normalizeCommunityTagName; },
/* harmony export */   "jJ": function() { return /* binding */ MAX_COMMUNITY_TAG_LENGTH; },
/* harmony export */   "l6": function() { return /* binding */ MAX_COMMUNITY_TAG_COUNT; },
/* harmony export */   "rA": function() { return /* binding */ isValidCommunityTagName; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var MAX_COMMUNITY_TAG_COUNT = 5;
var MAX_COMMUNITY_TAG_LENGTH = 20;
var COMMUNITY_TAG_ALLOWED_REGEX = /^[0-9A-Za-z가-힣ㄱ-ㅎㅏ-ㅣ_]{1,20}$/;
var normalizeCommunityTagName = function(tag) {
    return tag.trim().replace(/^#+/, "").slice(0, MAX_COMMUNITY_TAG_LENGTH);
};
var isValidCommunityTagName = function(tag) {
    return COMMUNITY_TAG_ALLOWED_REGEX.test(tag);
};
var getCommunityTagNamesWithInput = function(tags, inputValue) {
    var normalizedTag = normalizeCommunityTagName(inputValue);
    if (tags.length >= MAX_COMMUNITY_TAG_COUNT || !isValidCommunityTagName(normalizedTag) || tags.includes(normalizedTag)) {
        return tags;
    }
    return _toConsumableArray(tags).concat([
        normalizedTag
    ]);
};
var getCommunityTagNamesWithRecommendations = function(tags, inputValue, recommendedTagNames) {
    var tagsWithInput = getCommunityTagNamesWithInput(tags, inputValue);
    return recommendedTagNames.reduce(function(mergedTags, recommendedTagName) {
        return getCommunityTagNamesWithInput(mergedTags, recommendedTagName);
    }, tagsWithInput);
};
var getCommunityTagNamesFromTags = function(tags) {
    var ref;
    return (ref = tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
        return tag.name;
    }).filter(Boolean)) !== null && ref !== void 0 ? ref : [];
};


/***/ })

}]);